import React from 'react'
import car1 from '../../assets/car-02.png'
import { RiUserLocationFill } from "react-icons/ri";
import { FaLocationDot } from "react-icons/fa6";
import { LuCalendarDays } from "react-icons/lu";
import { IoIosTimer } from "react-icons/io";





const Homeprocess = () => {
    return (
        <div className='container my-6' >
            <div className='row' >
                <div className='col-md-6 my-auto' >
                    <img src={car1} className='img-fluid' />
                </div>
                <div className='col-md-6'>
                    <h1 className='text-center font accentColor mb-3' >How it Works</h1>


                    <div className='text-center' >
                        <div className='d-flex flex-column align-items-center justify-content-center' >
                            <div className="step" >
                                <RiUserLocationFill className='step-icon' />
                            </div>
                            <p className='step-text' >Choose pick up location</p>
                        </div>
                        <hr width="1" size="100" className='vertical-line' />
                        <div className='d-flex flex-column align-items-center justify-content-center' >
                            <div className="step" >
                                <FaLocationDot className='step-icon' />
                            </div>
                            <p className='step-text' >Choose Return location</p>
                        </div>
                        <hr width="1" size="100" className='vertical-line' />
                        <div className='d-flex flex-column align-items-center justify-content-center' >
                            <div className="step" >
                                <LuCalendarDays className='step-icon' />
                            </div>
                            <p className='step-text' >Choose Pick up date & time</p>
                        </div>
                        <hr width="1" size="100" className='vertical-line' />
                        <div className='d-flex flex-column align-items-center justify-content-center' >
                            <div className="step" >
                                <IoIosTimer className='step-icon' />
                            </div>
                            <p className='step-text' >Choose Return date & time</p>
                        </div>
                    </div>


                </div>
            </div>

        </div>
    )
}

export default Homeprocess
